import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PortalLayout from '@/components/portal/PortalLayout';
import { ConversationsListPage } from '@/components/builder/ConversationsListPage';

export default function PortalConversations() {
  const { chatbotId } = useParams<{ chatbotId: string }>();
  const navigate = useNavigate();

  if (!chatbotId) {
    // Redirect to chatbots list if no chatbotId provided
    navigate('/portal/chatbots');
    return null;
  }

  const handleBack = () => {
    navigate('/portal/chatbots');
  };

  return (
    <PortalLayout>
      <div className="container mx-auto py-6 space-y-6">
        <ConversationsListPage 
          chatbotId={chatbotId} 
          onBack={handleBack}
        />
      </div>
    </PortalLayout>
  );
}
